




















































































import {Component, Vue,} from 'vue-property-decorator';
import {CloseNodeDto, ConnectionServiceProxy} from '@/service-proxies/app-v2/iot-extranetv2-serve.service-proxies';
import TrafficData from "@/views/console/remote-connect-manage/component/TrafficData.vue";

@Component({
  components: {
    TrafficData
  },
})
export default class GatewayList extends Vue {
  conServProxy = new ConnectionServiceProxy();
  columns = [
    {
      title: '操作',
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      },
    },
    {
      title: '网关',
      dataIndex: 'nodeId',
      key: 'nodeId',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
      },
      onFilter: (value, record) =>
          record.nodeId
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
    },
    {
      title: '流量',
      dataIndex: 'displayTraffic',
      key: 'displayTraffic',
    },
    {
      title: '登录时间',
      dataIndex: 'loginTime',
      key: 'loginTime',
      scopedSlots: {
        customRender: 'loginTime'
      },
    }/*,
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Tags',
      key: 'tags',
      dataIndex: 'tags',
      scopedSlots: { customRender: 'tags' },
    },
    {
      title: 'Action',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },*/
  ];

  data = [];
  gatewayCodeSelect = ''

  searchInput = null;
  searchText = '';
  searchedColumn = null;
  visible = false;
  modelTitle = '';

  showModal(nodeId) {
    this.visible = true;
    this.modelTitle = nodeId
  }

  handleOk() {
    this.visible = false;
  }

  handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = '';
  }

  handleReset(clearFilters) {
    clearFilters();
    this.searchText = '';
  }

  mounted() {
    this.refreshList();
  }

  refreshList() {
    this.gatewayCodeSelect = ''
    this.conServProxy.findGatewayNodeList()
        .then(res => {
          this.data = res.data;
        })
  }

  confirmRemoteNode(nodeId) {
    //
    const dto = new CloseNodeDto();
    dto.nodeId = nodeId;
    this.conServProxy.closeGatewayNode(dto)
        .then(res => {
          this.refreshList();
        })
  }

  search(){
    this.conServProxy.findGatewayNodeList()
        .then(res => {
          let newData = res.data;
          this.data = newData
          if (this.gatewayCodeSelect){
            this.data = newData.filter( (item) => item.nodeId.indexOf(this.gatewayCodeSelect.trim().toUpperCase()) != -1)
          }
        })
  }
}
